import React, { useEffect, useRef, useState } from "react";
import DataTableListing from "../DataTableListing/DataTableListing";
import BackButton from "../BackButton/BackButton";
import "./LearningSpecialist.css";
import trash from "../../assets/images/delete.svg";
import sort from "../../assets/images/sort.png";
import search_bar from "../../assets/images/search.svg";
import LearningSpecialistStudents from "./LearningSpecialistStudents";
import AccessRoleModal from "../AccessRoleModal/AccessRoleModal";
import { useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {getAccessControlRole, resetAccessControlRoleList} from "../../state/actions/getAccessControlRoleAction";
import { useAuth } from "../../features/auth/AuthContext";
import api from "../../api/api";
import ConfirmDeleteModal from "../AccessRoleModal/ConfirmDeleteModal";
import { toast } from "react-toastify";
import defaultAvatar from "../../assets/images/Teacher_profile.png";
import EnrollmentResponsiveCards from "../../modules/admin/Dashboard/RecentEnrollment/EnrollmentResponsiveCards";
import SearchComponent from "../SearchComponent/SearchComponent";
// Advisors Page
function LearningSpecialist({isPreview=false}) {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {token} = useAuth();
  const [searchText, setSearchText] = useState("");
  const [openViewStudents, setOpenViewStudents] = useState(
    location.state?.openViewStudents ?? false  // ← initialize from state directly
  );
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [sortValue, setSortValue] = useState("");
  const sortRef = useRef(null);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const sortOptions = [
    { label: "Name : A - Z", value: "Name:A-Z" },
    { label: "Name : Z - A", value: "Name:Z-A" },
    { label: "Newest First", value: "Newest" },
    { label: "Oldest First", value: "Oldest-First" },
    {label : "Active Users", value: "active"},
    {label : "Inactive Users", value: "inactive"},
  ];

  useEffect(() => {
  setCurrentPage(1);
}, [sortValue, debouncedSearch]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sortRef.current && !sortRef.current.contains(e.target)) {
        setShowSortMenu(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

    useEffect(() => {
    const timer = setTimeout(() => setDebouncedSearch(searchText), 400);
    return () => clearTimeout(timer);
  }, [searchText]);
      // Update fetch to include sort
    useEffect(() => {
      if (openViewStudents) return;//// don't fetch list if showing students
      dispatch(getAccessControlRole(token, "ls", "list", undefined, sortValue || undefined, undefined, debouncedSearch || undefined, currentPage,));
      // return () => {
      //   dispatch(resetAccessControlRoleList()); // ← cleanup here
      // };
    }, [token, sortValue, debouncedSearch, currentPage, openViewStudents]);
const {roleList: LearningSpecialist, isLoading, count } = useSelector(
  (state) =>state.getAccessControlRoleList
)

   useEffect(() => {
      if (location.state?.openViewStudents) {
        navigate("/dashboard/learning-specialist", { replace: true, state: {} });
      }
    }, []); // run once on mount only
const [statuses, setStatuses] = useState({});
  const [selectedSpecialist, setSelectedSpecialist] = useState(   
     location.state?.ls ?? null            // ← initialize from state directly
  );
  const [deleteModal, setDeleteModal] = useState({ open: false, row: null });

// Add toggleStatus API call
const toggleStatus = async (specialist_id, currentStatus, user_id) => {
  setStatuses((prev) => ({
    ...prev,
    [specialist_id]: prev[specialist_id] !== undefined ? !prev[specialist_id] : !currentStatus,
  }));

  try {
    const result = await api.post(
      "super-admin/school/active-deactive/",
      {
        user_id: user_id,
        active: !currentStatus,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    if (result.status === 200) {
      toast.success(
        !currentStatus
          ? "Learning Specialist account has been enabled."
          : "Learning Specialist account has been disabled.",
        { position: "top-center" }
      );
      // dispatch(getAccessControlRole(token, "ls", "list")); // ← re-fetch so status is fresh from backend
    } else {
      // ── Revert on failure ──
      setStatuses((prev) => ({
        ...prev,
        [specialist_id]: currentStatus,
      }));
    }
  } catch (error) {
    // ── Revert on error ──
    setStatuses((prev) => ({
      ...prev,
      [specialist_id]: currentStatus,
    }));
    console.error("Toggle failed:", error.response?.data ?? error.message);
  }
};

const handleDelete = (row) => setDeleteModal({ open: true, row });

// Add delete handler
const confirmDelete = async () => {
  const row = deleteModal.row;
  setDeleteModal({ open: false, row: null });

  try {
    const result = await api.delete("adminpage/access-control/delete/", {
      headers: { "Content-Type": "application/json", Authorization: `Token ${token}` },
      data: {
        type: "ls",   // ← different type for student removal
        teacher_id: row.specialist_id
      },
    });
    if (result.data?.status === 200) {
       toast.success("Learning Specialist has been removed successfully.");
      dispatch(getAccessControlRole(token, "ls", "list")); // re-fetch
    } else {
      console.error("Delete failed:", result.data?.message);
    }
  } catch (error) {
    console.error("Delete error:", error.response?.data ?? error.message);
  }
};

const formatDate = (dateStr) => {
  if (!dateStr) return "—";
  const date = new Date(dateStr);
  const day = date.toLocaleString("en-GB", { day: "2-digit" });
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month}, ${year}`;
};
const totalCount = count ?? 0;
  // Columns
  const columns = [
    {
      key: "specialist_name",
      title: "Specialist Name",
      render: (value, row) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {row.ai_avatar ? (
            <img
              src={row.ai_avatar || defaultAvatar}
              alt={value}
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                objectFit: "cover",
                flexShrink: 0,
              }}
            />
          ) : (
            <div
              style={{
                width: 32,
                height: 32,
                borderRadius: "50%",
                background: "#e2e8f0",
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                color: "#94a3b8",
                fontWeight: 600,
              }}
            >
              {value?.charAt(0)}
            </div>
          )}
          <span>{value}</span>
        </div>
      ),
    },
    {
      key: "specialist_id",
      title: "Specialist Id",
      sortable: false,
      headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ),
    },
    {
      key: "student_enroll_count",
      title: "Students Enrolled",
      headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {value}
        </div>
      ),
    },
    {
      key: "email",
      title: "Email Id",
      sortable: false,
    },
    {
      key: "created_at",
      title: "Joining Date",
      headerStyle: { textAlign: "center" },
      render: (value) => (
        <div style={{ textAlign: "center" }}>
          {formatDate(value)}
        </div>
      ),
    },
    {
      key: "status",
      title: "Status",
      headerStyle: { textAlign: "center" },
       render: (_, row) => {
    const isActive = statuses[row.specialist_id] ?? (row.status?.toLowerCase() === "active");
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
      <div
        onClick={() => toggleStatus(row.specialist_id, isActive, row.user_id)}
        style={{
          width: 90,
          height: 30,
          borderRadius: 999,
          background: isActive ? "#E0F4FF" : "#f1f5f9",
          cursor: "pointer",
          position: "relative",
          display: "flex",
          alignItems: "center",
          transition: "background 0.25s",
          flexShrink: 0,
        }}
      >
        {/* Label */}
        <span
          style={{
            position: "absolute",
            left: isActive ? 12 : 30,
            fontSize: 12.5,
            fontWeight: 500,
            color: isActive ? "#0068FF" : "#94a3b8",
            transition: "left 0.25s",
            userSelect: "none",
          }}
        >
          {isActive ? "Active" : "Inactive"}
        </span>

        {/* Circle */}
        <div
          style={{
            width: 22,
            height: 22,
            borderRadius: "50%",
            background: "#fff",
            position: "absolute",
            right: isActive ? 4 : 4,
            left: isActive ? "auto" : "auto",
            ...(isActive ? { right: 4 } : { left: 4 }),
            boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
            transition: "all 0.25s",
          }}
        />
      </div>
      </div>
    );
    },
  },
    {
      key: "action",
      title: "Action",
      headerStyle: { textAlign: "center" },
      render: (_, row, __, isHovered) => (
        <div style={{ display: "flex", alignItems: "center",justifyContent:"center", gap: 12 }}>
          <span
            style={{
              color: "#0068FF",
              fontSize: 13.5,
              fontWeight: 500,
              cursor: "pointer",
              textDecoration: "none",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if(isPreview){
                navigate(`/dashboard/learning-specialist`, {
                  state: {openViewStudents:true ,ls: row },
                });
              }else{
                setSelectedSpecialist(row);
                setOpenViewStudents(true);
              }
            }}
          >
            View Students
          </span>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDelete(row);
            }}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 4,
              borderRadius: 4,
              display: "flex",
              alignItems: "center",
              color: "#9ca3af",
            }}
          >
            <img width="14" height="15" src={trash} alt="trash" />
          </button>
        </div>
      ),
    },
  ];

  // const filteredData = LearningSpecialist ?? [];
  const filteredData = isPreview ? (LearningSpecialist ?? []).slice(0, 10) : (LearningSpecialist ?? []); //filtering recent 10 data for dashboard and all data for individual tab

  const navigateBack = () => {
    setOpenViewStudents(false);
    // dispatch(resetAccessControlRoleList()); 
    // dispatch(getAccessControlRole(token, "ls", "list", undefined, sortValue || undefined, undefined, debouncedSearch || undefined)); // re-fetch on back 
  }

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);

  return (
    <>
    <div>
      {openViewStudents ? (
        <LearningSpecialistStudents navigateBack={navigateBack} specialist={selectedSpecialist} />
      ) : (
        <>
         {!isPreview && <BackButton handleClick={() => navigate("/dashboard/home")} buttonName="Back" />}

          {/* Toolbar */}
          <div className="specialist-toolbar">
            <div className="specialist-left-tools">
            {!isPreview && <h3>Learning Specialist</h3> }
              {/* Search */}
              <SearchComponent 
                search={search_bar}
                searchPlaceholder="Search Learning Specialist"
                value={searchText}
                onchange={(e) => setSearchText(e.target.value)}
              />
             {/*  <div className="search-bar">
                <img src={search_bar} alt="search-bar" />
                 <div className="search-divider"></div>
                <input
                  placeholder="Search Learning Specialist"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
              </div> */}
            </div>

            <div className="specialist-right-tools">
              {/* Sort button */}
            <div style={{ position: "relative" }} ref={sortRef}>
                  <button className="sort-button" onClick={() => setShowSortMenu((prev) => !prev)}>
                    <img src={sort} alt="sort" />
                    Sort
                  </button>

                  {showSortMenu && (
                    <div className="sort-menu">
                      {sortOptions.map((option) => (
                        <div className="sort-options"
                          key={option.value}
                          onClick={() => {
                            setSortValue(option.value);
                            setShowSortMenu(false);
                          }}
                          style={{
                            color: sortValue === option.value ? "#0068FF" : "#374151",
                            fontWeight: sortValue === option.value ? 600 : 400,
                            background: sortValue === option.value ? "#f0f7ff" : "#fff",
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.background = "#f9fafb"}
                          onMouseLeave={(e) => e.currentTarget.style.background = sortValue === option.value ? "#f0f7ff" : "#fff"}
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

              {/* Assign Students */}
              <button
                className="add-specialist-button"
                onClick={() =>{handleOpen()}}
              >
                + Add Specialist
              </button>
            </div>
          </div>

          {/* DataTable */}
          <div>
                {isMobile ? (
                <EnrollmentResponsiveCards
                  data={filteredData.map((item) => ({
                    ...item,
                    id: item.specialist_id,
                    specialist_id: item.specialist_id,
                    profilePic: item.ai_avatar,
                    is_active: item.status?.toLowerCase() === "active",
                    name: item.specialist_name || "Unknown",
                    email: item.email || "-",
                    studentsEnrolled: item.student_enroll_count || 0,
                    joinDate: formatDate(item.created_at) || "—",
                  }))}
                  userType="specialist"
                  onToggleStatus={(id, is_active, user_id) =>
                    toggleStatus(id, is_active, user_id)
                  }
                  onCardClick={(item) => {
                    if (isPreview) {
                      navigate(`/dashboard/learning-specialist`, {
                        state: { openViewStudents: true, ls: item },
                      });
                    } else {
                      setSelectedSpecialist(item);
                      setOpenViewStudents(true);
                    }
                  }}
                  statuses={statuses}
                  loading={isLoading}
                  pagination={
                    isPreview
                      ? false
                      : totalCount > 12
                      ? {
                          currentPage: currentPage,
                          total: totalCount,
                          pageSize: 12,
                          onChange: (page) => setCurrentPage(page),
                        }
                      : false
                  }
                  onDelete={handleDelete}
                />
              ) : (
                <DataTableListing
                  columns={columns}
                  dataSource={filteredData}
                  rowKey="specialist_id"
                  pagination={
                    isPreview
                      ? false
                      : totalCount > 12
                      ? {
                          currentPage: currentPage,
                          total: totalCount,
                          pageSize: 12,
                          onChange: (page) => setCurrentPage(page),
                        }
                      : false
                  }
                  checkable={false}
                  loading={isLoading}
                  emptyText="No Learning Specialist found"
                  bordered={false}
                  size="default"
                  rowHoverColor="#F7F7F7"
                />
              )}
          </div>
        </>
      )}
    </div>

    
  <AccessRoleModal open={open} onClose={() => setOpen(false)} mode="specialist" role="ls"
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
  >
  </AccessRoleModal>

  <ConfirmDeleteModal
    open={deleteModal.open}
    onClose={() => setDeleteModal({ open: false, row: null })}
    onConfirm={confirmDelete}
    name={deleteModal.row?.specialist_name}
    role="ls"
  />
    </>
  );
}

export default LearningSpecialist;
